export default "__VITE_ASSET__CIC1$BLs__"